import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

export default function ConfirmDeleteDialog({ open, onOpenChange, title, description, onConfirm, loading, testIdPrefix = "confirm-delete" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border border-zinc-900 rounded-none" data-testid={`${testIdPrefix}-dialog`}>
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display uppercase tracking-tight">{title}</AlertDialogTitle>
          <AlertDialogDescription data-testid={`${testIdPrefix}-description`}>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-none border-zinc-900" data-testid={`${testIdPrefix}-cancel`}>Annuler</AlertDialogCancel>
          <AlertDialogAction
            className="rounded-none bg-red-600 hover:bg-red-700 text-white border border-zinc-900"
            disabled={loading}
            onClick={(e) => { e.preventDefault(); onConfirm(); }}
            data-testid={`${testIdPrefix}-confirm`}
          >
            {loading ? "Suppression…" : "Supprimer"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
